/* eslint-disable react/no-string-refs, no-nested-ternary */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ID, withCodes } from 'app/blocks/common/codes';
import { tryCatch } from 'app/blocks/common/decorators';
import StaticContent from 'app/blocks/static-content/static-content';
import SearchAdvancedResult from 'app/pages/search/_advanced/_result/search_advanced_result';
import ContentSearchForm from 'app/pages/search/_advanced/content_search_form';
import Form from 'app/pages/search/_advanced/search_advanced.form';
import './advance_content_search.scss';
import NoArticleResults from 'app/pages/search/no-article-results/NoArticleResults';

export class AdvanceContentSearch extends Component {
    static propTypes = {
        context: PropTypes.shape({}),
        jid: PropTypes.string,
    };

    static defaultProps = {
        context: undefined,
        jid: undefined,
    };

    state = {
        action: 'provide',
        articleForm: Form.create(),
        jid: this.props.jid,
        journalForm: Form.create(),
        type: this.props.type,
    };

    @tryCatch
    async componentDidMount() {
        if (this.props.context) {
            const { context } = this.props;
            this.setState(
                {
                    action: 'search',
                    articleForm: context.articleForm,
                    context: this.props.context,
                    journalForm: context.journalForm,
                    type: this.props.type,
                },
                () => context.action === 'provide' && this.displayAttributes(),
            );
        }
    }

    displayAttributes = () => this.setState({ action: 'provide', context: null });

    search = (form, type) => this.setState({ action: 'search', form, type });

    clear = () => {
        const form = Form.create();
        if (this.state.type === 'journal') {
            this.setState({ journalForm: form });
        } else {
            this.setState({ articleForm: form, jid: null });
        }
    };

    render() {
        const { action, articleForm, form, jid, journalForm, type } = this.state;

        return (
            <main id="as-main-content-7f3d9e2a">
                {action === 'provide' ? (
                    <ContentSearchForm
                        ref="form"
                        articleForm={articleForm}
                        clear={this.clear}
                        jid={jid}
                        journalForm={journalForm}
                        onSearch={this.search}
                        type={type}
                    />
                ) : type === 'article' ? (
                    <SearchAdvancedResult
                        ref={r => {
                            // eslint-disable-next-line react/no-unused-class-component-methods
                            this.innerResults = r;
                        }}
                        articleForm={articleForm}
                        context={this.state.context}
                        form={form}
                        goBack={this.displayAttributes}
                        jid={jid}
                        journalForm={journalForm}
                        notfoundRender={() => <NoArticleResults goBack={this.displayAttributes} />}
                        type="article"
                    />
                ) : (
                    <SearchAdvancedResult
                        ref={r => {
                            // eslint-disable-next-line react/no-unused-class-component-methods
                            this.innerResults = r;
                        }}
                        articleForm={articleForm}
                        form={form}
                        goBack={this.displayAttributes}
                        journalForm={journalForm}
                        notfoundRender={() => (
                            <div className="page p-top_big p-btm_big">
                                <StaticContent
                                    key="advanced-search__no-results"
                                    src="advanced-search__no-results.html"
                                />
                            </div>
                        )}
                        title="Journal Search Results"
                        type="journal"
                    />
                )}
            </main>
        );
    }
}

export default withCodes(AdvanceContentSearch, ID.SEARCH_CODES);
